import { useEffect as s } from "react";
const c = ({ ref: e, callback: n, isDisabled: u = !1, ignoreNodesIds: o = [] }) => {
  s(() => {
    const t = (r) => {
      e && e.current && !e.current.contains(r.target) && !o.includes(r.target.id) && n();
    };
    return u ? document.removeEventListener("mousedown", t, !0) : document.addEventListener("mousedown", t, !0), () => {
      document.removeEventListener("mousedown", t, !0);
    };
  }, [n, e, u, o]);
};
export {
  c as default
};
